import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export default class TenByTenAnimations {
	constructor() {

		if(!document.querySelector('.tenbyten')) return;

		window.scrollTo(0, 0);

		this.elements = {
			moon: '.tenbyten-moon:not(.moon-modal)',
			text: '.tenbyten-top__text',
			logoTop: '.tenbyten-top__lettering',
			divisor: '.tenbyten-divisor',
			slider: '.tenbyten-videos'
		}

		this.isMobile = window.matchMedia(`(${window.mediaQueries.breakDown.l})`).matches;

		gsap.registerPlugin(ScrollTrigger);
		this.entering = this.enteringAnimation();
	}

	enteringAnimation() {
		const { moon, text, logoTop, divisor } = this.elements;

		if(!document.querySelector(moon)) return

		gsap.set(moon, {xPercent: -50, yPercent: -100, opacity: 1})

		const enteringTl =
			gsap.timeline({onComplete: () => {
				this.topLeaving();
			}}
		);
		enteringTl
			.to(moon, {
				yPercent: this.isMobile ? -65.5 : -75.5,
				duration: .5
			})
			.fromTo(`${text} > *`, {
				y: 50,
				autoAlpha: 0,
			},
			{
				y: 0,
				autoAlpha: 1,
				stagger: .15
			}, '-=.2')
			.fromTo(`${logoTop}`, {
				scale: 0.5,
				autoAlpha: 0
			},
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1
			}, '-=.5')
			.to(divisor, {
				width: '100%'
			}, '-=1')

		return enteringTl;
	}

	topLeaving() {
		const { logoTop } = this.elements;

		const topLeavingTl = gsap.timeline();

		topLeavingTl
			.to(logoTop, {
				scale: .5,
				opacity: 0,
				y: -200,
			})

		ScrollTrigger.create({
			trigger: '.tenbyten-videos',
			animation: topLeavingTl,
			scrub: 1,
			start: 'top bottom',
			end: 'top center',
		})
	}

	sliderEntering() {

	}
}
